import React from "react";
import { Icon, IconProps } from "../Icon"; // Import the generic Icon component

export const PreviousArrow = (props: IconProps) => {
  return (
    <Icon
      classes={`${props.classes || ""} ons-icon--m ons-u-mr-xs`}
      height="24px"
      width="24px"
      viewBox="0 0 17 13"
      focusable={false}
    >
      <path d="M6.4.2.3 6.4c-.2.2-.2.4 0 .6l6.2 5.8c.2.2.4.1.6 0l.8-.9c.2-.2.1-.4 0-.6l-4-3.7h12.5c.2 0 .4-.2.4-.4V6c0-.2-.2-.4-.4-.4H3.8l4-4c.2-.1.2-.4.1-.5L7 .2c-.1-.1-.4-.1-.6 0z" />
    </Icon>
  );
};
